import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { takeUntil } from 'rxjs';

import { BaseComponent } from '@shared/utils';
import { SearchService } from '@shared/data/common/services/search.service';

@Component({
  selector: 'gtin-redirect',
  templateUrl: './gtin-redirect.component.html',
  styleUrls: ['./gtin-redirect.component.scss'],
})
export class GtinRedirectComponent extends BaseComponent implements OnInit {
  loading: boolean = true;
  errorMessage: string = '';
  gtin14: string = '';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly searchService: SearchService
  ) {
    super();
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.gtin14 = params.get('gtin14') || '';
      if (!this.gtin14 || this.gtin14.length !== 14) {
        this.errorMessage = 'that product link is invalid.';
        this.loading = false;
        return;
      }

      this.searchService
        .GetProductLink(this.gtin14, {}, true)
        .pipe(takeUntil(this.destroyed()))
        .subscribe({
          next: (data): void => {
            this.loading = false;
            if (data.found && data.productLink) {
              // TODO: Insert analytics code here before redirect
              // Analytics tracking code should be added here

              // Redirect to the product link
              window.location.href = data.productLink;
            } else {
              this.errorMessage = 'that product link is invalid.';
            }
          },
          error: () => {
            this.loading = false;
            this.errorMessage = 'that product link is invalid.';
          },
        });
    });
  }
}
